import { render } from "./Breadcrumb.vue?vue&type=template&id=288a2e68&scoped=true&ts=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts"

import "./Breadcrumb.vue?vue&type=style&index=0&id=288a2e68&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288a2e68"]])

export default __exports__